/**
 * Single source of truth for the locales the platform supports.
 * Both apps/marketing (next-intl) and apps/web (i18next) import from here.
 *
 * Phase 1 §09: en active, ar scaffolded RTL, es scaffolded.
 */

export const LOCALES = ['en', 'ar', 'es'] as const;
export type Locale = (typeof LOCALES)[number];

export const DEFAULT_LOCALE: Locale = 'en';

/** Locales whose translations are reviewed and ready to expose in the UI toggle. */
export const ACTIVE_LOCALES: readonly Locale[] = ['en'] as const;

export const LOCALE_LABELS: Record<Locale, string> = {
  en: 'English',
  ar: 'العربية',
  es: 'Español',
};

export const LOCALE_DIRECTION: Record<Locale, 'ltr' | 'rtl'> = {
  en: 'ltr',
  ar: 'rtl',
  es: 'ltr',
};

export function isLocale(value: string): value is Locale {
  return (LOCALES as readonly string[]).includes(value);
}

export function isActiveLocale(value: string): value is Locale {
  return (ACTIVE_LOCALES as readonly string[]).includes(value);
}
